import { BaseDict } from "../../../blocks/EventListPresenter/dict";
import { getFixtureCardProps } from "../getFixtureCardProps";
//added tests webpack issue
/* istanbul ignore next */
export var getOutrightCardProps = function (state, event, cms, dict) {
    return event.isLive
        ? getFixtureCardProps(state, event, cms, dict)
        : {
            event: event,
            markets: state.displayMarkets(event.id),
            handlers: {
                betButton: state.addToSlipTranspiler.bind(state)
            },
            showHeadingNames: state.shouldShowOutrightSubheading,
            numberOfSelectionsToShow: cms.NumberOfSelectionsToShow,
            viewAllProps: {
                linkUrl: event.linkUrl,
                onClick: state.openGameTranspiler.bind(state, event),
                text: dict.ViewAllOutrights
            },
            hideLowOdds: cms.HideLowOdds,
            dict: BaseDict
        };
};
//# sourceMappingURL=getOutrightCardProps.js.map